import React from "react"
import { Form } from "antd"
import Input from "antd/lib/input/Input"
import { useTranslation } from "react-i18next"

interface ITimeAtStopFormItemProps {
  label: string
  name: string
}

export const TimeAtStopFormItem: React.FC<ITimeAtStopFormItemProps> = ({ label, name }) => {
  const { t } = useTranslation()
  return (
    <Form.Item label={label} name={name} validateTrigger="onSubmit">
      <Input
        className="time-at-stop !max-w-[200px] !text-sm"
        type="number"
        size="small"
        prefix=" "
        addonAfter={t("common.minutes")}
        style={{ borderRadius: "none !important" }}
      />
    </Form.Item>
  )
}
